import React from 'react';
import Select from '../../../components/ui/Select';
import { Checkbox, CheckboxGroup } from '../../../components/ui/Checkbox';

const AcademicBackgroundStep = ({ formData, errors, onChange, onCheckboxChange }) => {
  const educationLevelOptions = [
    { value: 'sixieme', label: 'Sixième (6ème)' },
    { value: 'cinquieme', label: 'Cinquième (5ème)' },
    { value: 'quatrieme', label: 'Quatrième (4ème)' },
    { value: 'troisieme', label: 'Troisième (3ème)' },
    { value: 'seconde', label: 'Seconde (2nde)' },
    { value: 'premiere', label: 'Première (1ère)' },
    { value: 'terminale', label: 'Terminale' }
  ];

  const seriesOptions = [
    { value: 'l', label: 'Série L (Littéraire)' },
    { value: 's', label: 'Série S (Scientifique)' },
    { value: 'g', label: 'Série G (Gestion)' },
    { value: 't', label: 'Série T (Technique)' }
  ];

  const performanceOptions = [
    { value: 'excellent', label: 'Excellent (16-20)' },
    { value: 'tres-bien', label: 'Très Bien (14-16)' },
    { value: 'bien', label: 'Bien (12-14)' },
    { value: 'assez-bien', label: 'Assez Bien (10-12)' },
    { value: 'passable', label: 'Passable (8-10)' }
  ];

  const subjectsList = [
    { id: 'mathematiques', label: 'Mathématiques' },
    { id: 'physique-chimie', label: 'Physique-Chimie' },
    { id: 'svt', label: 'Sciences de la Vie et de la Terre (SVT)' },
    { id: 'francais', label: 'Français' },
    { id: 'anglais', label: 'Anglais' },
    { id: 'histoire-geo', label: 'Histoire-Géographie' },
    { id: 'philosophie', label: 'Philosophie' },
    { id: 'economie', label: 'Économie' },
    { id: 'informatique', label: 'Informatique' },
    { id: 'arts', label: 'Arts Plastiques' },
    { id: 'eps', label: 'Éducation Physique et Sportive (EPS)' },
    { id: 'arabe', label: 'Arabe' }
  ];

  return (
    <div className="space-y-4 md:space-y-5 lg:space-y-6">
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 md:p-5 lg:p-6">
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 w-8 h-8 md:w-10 md:h-10 lg:w-12 lg:h-12 bg-blue-500 rounded-full flex items-center justify-center">
            <span className="text-white text-sm md:text-base lg:text-lg font-semibold">2</span>
          </div>
          <div>
            <h3 className="text-base md:text-lg lg:text-xl font-semibold text-gray-900 mb-1 md:mb-2">
              Parcours Académique
            </h3>
            <p className="text-sm md:text-base text-gray-600">
              Parlez-nous de votre parcours scolaire actuel pour mieux vous orienter.
            </p>
          </div>
        </div>
      </div>
      <Select
        label="Niveau d'Études Actuel"
        options={educationLevelOptions}
        value={formData?.educationLevel}
        onChange={(value) => onChange({ target: { name: 'educationLevel', value } })}
        placeholder="Sélectionnez votre niveau"
        error={errors?.educationLevel}
        required
      />
      {(formData?.educationLevel === 'seconde' || 
        formData?.educationLevel === 'premiere' || 
        formData?.educationLevel === 'terminale') && (
        <Select
          label="Série"
          options={seriesOptions}
          value={formData?.series}
          onChange={(value) => onChange({ target: { name: 'series', value } })}
          placeholder="Sélectionnez votre série"
          description="Applicable uniquement pour le lycée"
          error={errors?.series}
        />
      )}
      <Select
        label="Performance Académique Générale"
        options={performanceOptions}
        value={formData?.performance}
        onChange={(value) => onChange({ target: { name: 'performance', value } })}
        placeholder="Sélectionnez votre niveau"
        description="Basé sur vos notes moyennes récentes"
        error={errors?.performance}
        required
      />
      <div>
        <CheckboxGroup 
          label="Matières Préférées" 
          error={errors?.favoriteSubjects}
        >
          <p className="text-sm text-gray-600 mb-3 md:mb-4">
            Sélectionnez au moins 3 matières que vous aimez le plus
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
            {subjectsList?.map((subject) => (
              <Checkbox
                key={subject?.id}
                label={subject?.label}
                checked={formData?.favoriteSubjects?.includes(subject?.id)}
                onChange={(e) => onCheckboxChange('favoriteSubjects', subject?.id, e?.target?.checked)}
              />
            ))}
          </div>
        </CheckboxGroup>
      </div>
    </div>
  );
};

export default AcademicBackgroundStep;